import React, { useState } from 'react';
import { Space } from 'antd';
import styles from './index.module.scss';

// 时间颗粒度（水的能流趋势）
export enum DateTypeByWater {
  DAY = 1,
  MONTH = 2,
}

export const DateTypeByWaterDisplay = {
  [DateTypeByWater.DAY]: '按日',
  [DateTypeByWater.MONTH]: '按月',
};

// 定义组件属性接口
interface SwitchDateProps {
  options: { label: string; value: DateTypeByWater }[];
  defaultValue?: DateTypeByWater;
  onChange?: (value: DateTypeByWater) => void;
  className?: string;
}

// 定义组件
const FlowSwitchDate: React.FC<SwitchDateProps> = ({ defaultValue, options, onChange, className }) => {
  const [activeKey, setActiveKey] = useState<DateTypeByWater | undefined>(defaultValue);

  const handleDateChange = (value: DateTypeByWater) => {
    setActiveKey(value);
    onChange?.(value);
  };

  return (
    <Space size={8} className={className}>
      {options.map((item, index) => (
        <div
          key={index}
          className={`${styles.dateBtn} ${activeKey === item.value && styles.active}`}
          onClick={() => handleDateChange(item.value)}
        >
          {item.label}
        </div>
      ))}
    </Space>
  );
};

export default FlowSwitchDate;
